var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"linechart",staticStyle:{"width":"100% !important","height":"380px !important"}})}
var staticRenderFns = []

export { render, staticRenderFns }